import * as Yup from 'yup'
import { FormKeys } from './SignUpForm.interface'

export const phoneRegExp =
/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const websiteUrlRegex = /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-z0-9#$-_.+! *'(),]+)*\/?(\?[a-za-z0-9-_]+=[a-za-z0-9-%]+&?)?$/gim

export const validationSchema = Yup.object().shape({
  [FormKeys.BUSINESS_NAME]: Yup.string().required('Business name is required'),
  [FormKeys.WEBSITE_URL]: Yup.string().required('Website URL is required').matches(websiteUrlRegex, 'Please enter a valid url'),
  [FormKeys.TELEPHONE_NUMBER]: Yup.string().matches(phoneRegExp, 'Please enter a valid phone number.').min(11, 'Please enter a valid phone number with 11 digits.'),
  [FormKeys.ADDRESS]: Yup.string().required('Address is required'),
  [FormKeys.SHORT_DESCRIPTION]: Yup.string().required('Short description is required').max(40, 'Must be 40 characters or less'),
  [FormKeys.LONG_DESCRIPTION]: Yup.string().required('Long description is required').max(120, 'Must be 120 characters or less'),
  [FormKeys.IS_INDEPENDANT]: Yup.string().required('Independent field is required'),
  [FormKeys.BUSINESS_TYPE]: Yup.string().required('Business type is required'),
  [FormKeys.CATEGORIES]: Yup.array().of(Yup.string()).required('required').max(5, 'Must be 5 categories or less'),
  [FormKeys.PRIMARY_IMAGE]: Yup.string().required('At least one image is required'),
  [FormKeys.SECONDARY_IMAGE]: Yup.string(),
  [FormKeys.THIRD_IMAGE]: Yup.string(),
  [FormKeys.CONTACT_NAME]: Yup.string().required('Your name is required'),
  [FormKeys.CONTACT_EMAIL]: Yup.string().email('Please enter a valid email address').required('Your email address is required'),
  [FormKeys.CAPTCHA]: Yup.string().required('Please confirm you’re not a robot'),
  [FormKeys.PLURALISED_CATEGORY_NAME]: Yup.string()
})
